import React from 'react';
import { ErrorMessage } from '@utils/error';
import { ErrorDisplay } from './ErrorDisplay';
import { Loading } from './Loading';

interface LoadingContentProps {
  loading: boolean;
  loadingComponent?: React.ReactNode;
  error?: { info?: ErrorMessage };
  errorComponent?: React.ReactNode;
  children: React.ReactNode;
}

export function LoadingContent(props: LoadingContentProps) {
  if (props.error) {
    return props.errorComponent ? (
      <>{props.errorComponent}</>
    ) : (
      <div className="mt-4">
        <ErrorDisplay info={props.error.info} />
      </div>
    );
  }

  if (props.loading) return <>{props.loadingComponent || <Loading />}</>;

  return <>{props.children}</>;
}
